<template>
  <el-dialog
    :title="titleMsg"
    :visible.sync="showAppletSpecial.flag"
    width="700px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    distroy-on-close
  >
    <el-form
      :model="ruleForm"
      ref="ruleForm"
      :rules="rules"
      label-width="120px"
      class="form"
      size="small"
    >
      <el-row>
        <el-col :span="20">
          <el-form-item label="名称：" prop="name">
            <el-input
              placeholder="请输入名称"
              v-model="ruleForm.name"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item
            label="icon图片："
            prop="coverUrl"
            :rules="[rulesFactory.required('请上传icon图片')]"
          >
            <div
              v-if="ruleForm.coverUrl"
              class="video-output"
              @mouseenter="showCover = true"
              @mouseleave="showCover = false"
            >
              <img :src="ruleForm.coverUrl" class="avatar" />
              <div v-show="showCover" class="cover-bg">
                <i
                  class="el-icon-zoom-in delete"
                  @click.stop="handleShowViewer()"
                ></i>
                <i
                  class="el-icon-delete delete"
                  @click.stop="deleteCoverApplet()"
                ></i>
              </div>
            </div>
            <el-upload
              v-else
              action=""
              class="avatar-uploader"
              :show-file-list="false"
              :http-request="uploadCover"
              accept="png,jpg,jpeg"
              :limit="1"
              ref="coverUpload"
            >
              <i class="el-icon-plus avatar-uploader-icon"></i>
              <label v-if="!ruleForm.coverUrl" class="upload-text"
                >上传图片</label
              >
            </el-upload>
            <div class="upload_tip">
              <p class="img_tip">建议尺寸：60px*60px</p>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="scale" label="跳转类型：" prop="skipType">
            <el-radio-group v-model="ruleForm.skipType">
              <el-radio
                v-for="item in skipTypeData"
                :key="item.paramKey"
                :label="Number(item.paramKey)"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="ruleForm.skipType == 1">
        <el-col :span="8">
          <el-form-item label="资源：" prop="resourceType">
            <el-select
              class="resourceType_style"
              v-model="ruleForm.resourceType"
              placeholder="请选择资源类型"
              @change="changeResourceType"
            >
              <el-option
                v-for="item in resourceTypeData"
                :key="item.paramKey"
                :label="item.paramValue"
                :value="Number(item.paramKey)"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label-width="0px" prop="resourceId">
            <load-select
              v-if="ruleForm.resourceType == 0"
              style="width: 330px"
              v-model="ruleForm.resourceId"
              dictLabel="videoName"
              dictValue="uuid"
              :data="data"
              :page="page"
              :hasMore="more"
              :request="getVideoData"
              placeholder="请选择视频（输入视频名称关键字以查询）"
              :defaultVal="ruleForm.resourceName"
              :isInit="isInit"
              @change="sourceChange"
            />
            <load-select
              v-if="ruleForm.resourceType == 1"
              style="width: 330px"
              v-model="ruleForm.resourceId"
              dictLabel="name"
              dictValue="uuid"
              :data="data"
              :page="page"
              :hasMore="more"
              :request="getBookData"
              placeholder="请选择图书（输入图书名称关键字以查询）"
              :defaultVal="ruleForm.resourceName"
              :isInit="isInit"
              @change="sourceChange"
            />
            <load-select
              v-if="ruleForm.resourceType == 2"
              style="width: 330px"
              v-model="ruleForm.resourceId"
              dictLabel="name"
              dictValue="uuid"
              :data="data"
              :page="page"
              :hasMore="more"
              :request="getSubjectData"
              placeholder="请选择专题（输入专题名称关键字以查询）"
              :defaultVal="ruleForm.resourceName"
              :isInit="isInit"
              @change="sourceChange"
            />
            <load-select
              v-if="ruleForm.resourceType == 3"
              style="width: 330px"
              v-model="ruleForm.resourceId"
              dictLabel="name"
              dictValue="uuid"
              :data="data"
              :page="page"
              :hasMore="more"
              :request="getNewsData"
              placeholder="请选择新闻（输入新闻名称关键字以查询）"
              :defaultVal="ruleForm.resourceName"
              :isInit="isInit"
              @change="sourceChange"
            />
            <load-select
              v-if="ruleForm.resourceType == 4"
              style="width: 330px"
              v-model="ruleForm.resourceId"
              dictLabel="className"
              dictValue="uuid"
              :data="data"
              :page="page"
              :hasMore="more"
              :request="getClassData"
              placeholder="请选择班级（输入班级名称关键字以查询）"
              :defaultVal="ruleForm.resourceName"
              :isInit="isInit"
              @change="sourceChange"
            />
            <load-select
              v-if="ruleForm.resourceType == 5"
              style="width: 330px"
              v-model="ruleForm.resourceId"
              dictLabel="name"
              dictValue="uuid"
              :data="data"
              :page="page"
              :hasMore="more"
              :request="getArticleData"
              placeholder="请选择文章（输入文章关键字以查询）"
              :defaultVal="ruleForm.resourceName"
              :isInit="isInit"
              @change="sourceChange"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="ruleForm.skipType == 0 || ruleForm.skipType == 2">
        <el-col :span="20">
          <el-form-item label="链接地址：" prop="link">
            <el-input
              :placeholder="`请输入${
                ruleForm.skipType == 0 ? '外' : '内'
              }部链接`"
              v-model="ruleForm.link"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="ruleForm.skipType == 3">
        <el-col :span="20">
          <el-form-item
            class="scale"
            label="第三方平台："
            prop="clientOtherPlatformType"
          >
            <el-select
              v-model="ruleForm.clientOtherPlatformType"
              placeholder="请选择跳转的第三方平台"
              style="width: 100%"
            >
              <el-option
                v-for="item in platformTypeData"
                :key="item.paramKey"
                :label="item.paramValue"
                :value="Number(item.paramKey)"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click.native="closeDialog()" btntype title="取消"></butn>
      <butn btntype="primary" @click.native="sureSubmit()" title="确定"></butn>
    </div>
    <!-- 图片预览 -->
    <el-image-viewer
      v-if="showViewer"
      :on-close="closeAppletViewer"
      :url-list="[ruleForm.coverUrl]"
    />
  </el-dialog>
</template>
    
<script>
import { getSysParamByTypes } from "@/api/sysParam";
import FileHandler from "@/utils/file";
import rulesFactory from "@/utils/rules";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import {
  saveClientIndexConfig,
  getArticleByName,
  clientIndexConfigInfo,
} from "@/api/resourceService";
import butn from "@/components/button/index";
import LoadSelect from "@/components/load-select/index.vue";
import { getBookByName } from "@/api/book";
import { getPublishedClassList } from "@/api/class";
import { getNewsByName } from "@/api/news";
import { getSubjectByName } from "@/api/subjectInfo";
import { getVideoByName } from "@/api/video";

export default {
  components: { butn, ElImageViewer, LoadSelect },
  props: {
    showAppletSpecial: {
      type: Object,
      default: function () {
        return {
          id: "",
        };
      },
    },
  },
  data() {
    return {
      rulesFactory,
      titleMsg: "新增",
      editFlag: false,
      skipTypeData: [], // 跳转类型（TYPE：BANNER_SKIP_TYPE  0外链 1资源 2内链 3第三方平台）
      resourceTypeData: [], // 资源类型（TYPE：BANNER_RESOURCE_TYPE  0视频 1图书 2专题 3新闻 4班级 5文章）
      platformTypeData: [], // 第三方平台类型（TYPE：CLIENT_OTHER_PLATFORM_TYPE  1中网院 2八八战略网上展厅）
      page: 1,
      more: true,
      data: [],
      showCover: false,
      showViewer: false,
      isInit: true,
      ruleForm: {
        name: "",
        resourceType: 0,
        skipType: 0,
        resourceId: "",
        link: "",
        clientOtherPlatformType: null,
        coverUrl: "",
        resourceName: "",
      },
      rules: {
        name: [
          rulesFactory.required("请输入名称"),
          rulesFactory.size("最多输入8个字", 0, 8),
        ],
        skipType: [rulesFactory.required("请选择跳转类型")],
        resourceType: [rulesFactory.required("请选择资源类型")],
        link: [
          rulesFactory.required("请输入链接地址"),
          rulesFactory.size("最多输入1000个字", 0, 1000)
        ],
        resourceId: [rulesFactory.required("请选择资源")],
        clientOtherPlatformType: [rulesFactory.required("请选择跳转的第三方平台")], 
      },
    };
  },
  created() {
    this.getSysParamByTypes([
      "BANNER_SKIP_TYPE",
      "BANNER_RESOURCE_TYPE",
      "CLIENT_OTHER_PLATFORM_TYPE",
    ]);
    if (this.showAppletSpecial.id) {
      this.titleMsg = "编辑";
      this.editFlag = true;
      // 处理编辑或者详情
      this.getConfigInfo();
    } else {
      this.titleMsg = "新增";
      this.editFlag = false;
    }
  },
  methods: {
    changeResourceType(val) {
      this.data = [];
      this.page = 1;
      this.more = true;
      this.ruleForm.resourceId = "";
      this.ruleForm.resourceName = "";
    },
    handleShowViewer() {
      this.showViewer = true;
    },
    // 特色内容配置详情-clc
    getConfigInfo() {
      clientIndexConfigInfo(this.showAppletSpecial.id).then((res) => {
        if (res.code !== 0) return;
        let resp = res.data;
        this.ruleForm = resp;
      });
    },
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        this.skipTypeData = res.data["BANNER_SKIP_TYPE"] || [];
        this.resourceTypeData = res.data["BANNER_RESOURCE_TYPE"] || [];
        this.platformTypeData = res.data["CLIENT_OTHER_PLATFORM_TYPE"] || [];
        if (!this.editFlag) {
          this.ruleForm.resourceType = Number(
            this.resourceTypeData[2].paramKey
          );
          this.ruleForm.skipType = Number(this.skipTypeData[1].paramKey);
        }
      });
    },
    sourceChange() {
      this.isInit = false;
    },
    getVideoData({ page = 1, more = false, keyword = "" } = {}) {
      return new Promise((resolve) => {
        getVideoByName({ page, name: keyword }).then(({ code, data }) => {
          this.dealSource(more, code, data);
          resolve();
        });
      });
    },
    getBookData({ page = 1, more = false, keyword = "" } = {}) {
      return new Promise((resolve) => {
        getBookByName({ page, name: keyword }).then(({ code, data }) => {
          this.dealSource(more, code, data);
          resolve();
        });
      });
    },
    getSubjectData({ page = 1, more = false, keyword = "" } = {}) {
      return new Promise((resolve) => {
        getSubjectByName({ page, name: keyword }).then(({ code, data }) => {
          this.dealSource(more, code, data);
          resolve();
        });
      });
    },
    getNewsData({ page = 1, more = false, keyword = "" } = {}) {
      return new Promise((resolve) => {
        getNewsByName({ page, newsTitle: keyword }).then(({ code, data }) => {
          this.dealSource(more, code, data);
          resolve();
        });
      });
    },
    getClassData({ page = 1, more = false, keyword = "" } = {}) {
      return new Promise((resolve) => {
        getPublishedClassList({ page, className: keyword }).then(
          ({ code, data }) => {
            this.dealSource(more, code, data);
            resolve();
          }
        );
      });
    },
    getArticleData({ page = 1, more = false, keyword = "" } = {}) {
      return new Promise((resolve) => {
        getArticleByName({ page, className: keyword }).then(
          ({ code, data }) => {
            this.dealSource(more, code, data);
            resolve();
          }
        );
      });
    },
    dealSource(more, code, data) {
      if (code !== 0) return;
      if (more) {
        this.data = [...this.data, ...data.records];
      } else {
        this.data = data.records;
      }
      this.page = data.current;
      let { current, total, size } = data;
      this.more = current * size < total;
      this.page = current;
    },
    // 上传WEB封面
    async uploadCover(e) {
      let file = e.file;
      // 校验文件格式是否符合要求(png格式或者jpg格式)
      const image = await FileHandler.isImage(file);
      if (!image) {
        this.$message({
          message: "请上传格式为png、jpg格式的文件，其余文件格式无法上传哦！",
          type: "warning",
        });
        // 重点: 异常流程时必须要清除上传的文件，否则设置限制文件上传数量为1时不能再次执行上传事件
        this.$refs["coverUpload"].clearFiles();
        return;
      }
      FileHandler.uploadFile(`configInfo/img`, file).then((res) => {
        const { url } = res;
        this.ruleForm.coverUrl = url;
      });
    },
    // 删除配图-小程序
    deleteCoverApplet() {
      this.ruleForm.coverUrl = "";
    },
    closeAppletViewer() {
      this.showViewer = false;
    },
    closeDialog() {
      this.$emit("closeDialog", false);
    },
    sureSubmit() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          saveClientIndexConfig(this.ruleForm).then((res) => {
            if (res && res.code == 0) {
              this.$message.success(res.msg);
              // 更新数据
              this.$emit("closeDialog", true);
            }
          });
        }
      });
    },
  },
};
</script>
    
<style lang="scss" scoped>
$textColor: #51627d;
.resourceType_style {
  width: 100%;
}
.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  background-color: #f7f9fc;
  width: 320px;
  height: 160px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 70px;
  height: 70px;
  line-height: 70px;
  text-align: center;
}

.avatar {
  width: 320px;
  height: 160px !important;
  display: block;
  object-fit: contain;
}

.upload-text {
  color: $textColor;
  font-size: 13px;
}

.video-output {
  width: 320px;
  height: 160px;
  position: relative;

  .cover-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(1, 1, 1, 0.5);
    z-index: 199;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    color: #ffffff;

    .delete {
      font-size: 20px;
      cursor: pointer;
    }
  }
}

.upload_tip {
  width: 320px;
  text-align: center;
  margin-top: 10px;
}

.upload_tip p {
  font-size: 14px;
  margin: 0;
  line-height: 20px;
  color: #51627d;
}

.upload_tip p.img_tip {
  font-size: 12px;
  color: #96a1b2;
}
</style>
    